import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  Token: '',
}

export const firebaseReducer = createSlice({
  name: 'firebaseReducer',
  initialState,
  reducers: {
    setfirebaseToken: (state, action) => {
      state.Token = action.payload
    },


  },
})

export const { setfirebaseToken } = firebaseReducer.actions

export default firebaseReducer.reducer
